import { useContext } from "react";
import CartContext from "../../context/cart";
import CartSummary from "./cart-summary";
import CartThirdStream from "./cart-third-stream";
import UserContext from "../../context/user";

const Subcomponent = () => {
  const { labels, cartRequest } = useContext(CartContext);
  const { userProfile } = useContext(UserContext);

  if (cartRequest?.deliveryOption === "INDIRIZZO" && cartRequest?.contentId) {
    return <CartThirdStream />;
  }

  if (cartRequest?.defaultCartAssigned && cartRequest?.status === "CREATED") {
    return (
      <>
        <div
          className="carrello-content__text"
          dangerouslySetInnerHTML={{
            __html:
              labels?.WELFARE_CART_ASSIGNED ||
              "Ti comunichiamo che la piattaforma per effettuare la scelta è chiusa. Vogliamo rassicuranti comunque che ti viene riservato ugualmente un carrello, in modo che anche tu possa usufruire di questa iniziativa di welfare aziendale",
          }}
        />

        <CartSummary variant="default" readOnly={true} />
        <div
          className="carrello-content__text"
          dangerouslySetInnerHTML={{
            __html:
              labels?.WELFARE_CART_CONCLUSION ||
              "Per qualsisasi dubbio o informazione scrivi a: <a href='mailto:welfare@essilorluxottica.com'>welfare@essilorluxottica.com</a>",
          }}
        />
      </>
    );
  }

  if (!cartRequest?.defaultCartAssigned && cartRequest?.status === "CART_NOT_SELECTED") {
    return (
      <>
        <div
          className="carrello-content__text"
          dangerouslySetInnerHTML={{
            __html: (labels?.WELFARE_CART_CAMPAIGN_CLOSED).replace(
              "[USER]",
              `<span translate="no">${userProfile?.firstName} ${userProfile?.lastName}</span>`
            ),
          }}
        />
        <div
          className="carrello-content__text carrello-content__text--border-top"
          dangerouslySetInnerHTML={{
            __html: labels?.WELFARE_CONTACT_US_INFO,
          }}
        />
      </>
    );
  }
  return (
    <>
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html:
            labels?.WELFARE_CONFIRMATION_INFO ||
            "<p>The selected cart has been saved in the system.</p>",
        }}
      />
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{ __html: labels?.WELFARE_CART_CONCLUSION }}
      />
      <CartSummary variant="confirmation" readOnly={true} />
    </>
  );
};

const CartSelectionClosedPhase = () => {
  return (
    <div className="wrapper wrapper-small">
      <Subcomponent />
    </div>
  );
};

export default CartSelectionClosedPhase;
